export function onDataBound(grid, callback) {
	if (callback) {
		grid.bind('dataBound', callback);
	}
}
